export const LANGUAGE_FIELDS = {
  cultures: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
  enemies: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
};

export const BASIC_FILTER_CONFIGS = [
  {
    key: 'names',
    labelKey: 'active-substance|filters.Active substance name',
    field: 'name.keyword',
  },
  {
    key: 'cas_numbers',
    labelKey: 'active-substance|filters.CAS number',
    field: 'cas_numbers.keyword',
  },
  {
    key: 'cultures',
    labelKey: 'active-substance|filters.Cultures',
    field: 'cultures',
    value_field: 'id',
    label_field: 'french_name',
    languageConfig: LANGUAGE_FIELDS.cultures,
  },
  {
    key: 'activity_sectors',
    labelKey: 'active-substance|filters.Activity sector',
    field: 'activity_sectors',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'cultures_practices',
    labelKey: 'active-substance|filters.Cultural practices',
    field: 'cultures.cultural_practices',
    value_field: 'id',
    label_field: 'name',
  },
];

export const AGRONOMIC_FILTER_CONFIGS = [
  {
    key: 'chemical_families',
    labelKey: 'active-substance|filters.Chemical families or biological families',
    field: 'pesticide_group_associations.chemical_family',
    value_field: 'id',
    label_field: 'label',
  },
  {
    key: 'pesticide_groups',
    labelKey: 'active-substance|filters.Pesticide groups',
    field: 'pesticide_group_associations.pesticide_group',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'pesticide_categories',
    labelKey: 'active-substance|filters.Pesticide categories',
    field: 'pesticide_categories',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'pesticide_types',
    labelKey: 'active-substance|filters.Pesticide types',
    field: 'pesticide_types',
    value_field: 'id',
    label_field: 'label',
  },
  {
    key: 'activity_types',
    labelKey: 'active-substance|filters.Activity types',
    field: 'activity_types.activity_type',
    value_field: 'id',
    label_field: 'label',
  },
  {
    key: 'arla_culture_groups',
    labelKey: 'active-substance|filters.ARLA culture groups',
    field: 'cultures.arla_culture_group',
    value_field: 'id',
    label_field: 'group',
  },
  {
    key: 'resistance',
    labelKey: 'active-substance|filters.Resistance',
    field: 'pesticide_group_associations.pesticide_group.risk_of_resistance_development',
    value_field: 'id',
    label_field: 'name',
  },
];

export const HEALTH_FILTER_CONFIGS = [
  {
    key: 'acute_toxicity',
    labelKey: 'active-substance|filters.Acute toxicity',
    field: 'health.acute_toxicity_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'long_term_effects',
    labelKey: 'active-substance|filters.Long term effects',
    field: 'health.long_term_effect_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const ENVIRONMENT_FILTER_CONFIGS = [
  {
    key: 'fish_or_daphnia',
    labelKey: 'active-substance|filters.Fish or daphnia',
    field: 'environment.fishes_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'birds',
    labelKey: 'active-substance|filters.Birds',
    field: 'environment.birds_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'bees',
    labelKey: 'active-substance|filters.Bees',
    field: 'environment.bees_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'persistence',
    labelKey: 'active-substance|filters.Persistence',
    field: 'environment.persistence_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'leaching_potential',
    labelKey: 'active-substance|filters.Leaching potential',
    field: 'environment.leaching_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const BASIC_FILTER_KEYS = BASIC_FILTER_CONFIGS.map((c) => c.key);
export const EXTRA_FILTER_KEYS = [
  ...AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
  ...HEALTH_FILTER_CONFIGS.map((c) => c.key),
  ...ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
];

export const DOCUMENT_TYPE = 'SubstanceActiveDocument';